import api from './index.js'

export function getOrderList(params) {
  return api.get('/api/v1/orders', { params })
}

export function getOrderDetail(orderCode) {
  return api.get(`/api/v1/orders/${orderCode}`)
}

export function updateOrderStatus(orderCode, data) {
  return api.put(`/api/v1/orders/${orderCode}/status`, data)
}

export function updateOrderStatuses(data) {
  return api.put('/api/v1/orders/status', data)
}

export function cancelOrderPayment(orderCode, data) {
  return api.post(`/api/v1/orders/${orderCode}/payments/cancel`, data)
}

/** 수동 결제취소 — 온넥트 쪽은 사람이 이미 취소했고 주문 · 재고 · 원장만 되돌린다. memo 필수 */
export function manualCancelOrderPayment(orderCode, data) {
  return api.post(`/api/v1/orders/${orderCode}/payments/manual-cancel`, data)
}

export function refundOrderPayment(orderCode, data) {
  return api.post(`/api/v1/orders/${orderCode}/payments/refund`, data)
}
